import { ClickableIcon } from "components/Icon/ClickableIcon";
import { useTranslation } from "i18n";

import { MfaCodeForm } from "./MfaCodeForm";

export type VerifyMfaFormProps = {
  onGoBack?: () => void;
  onSubmit: (code: string) => Promise<"SUCCESS" | "ERROR">;
};

export const VerifyMfaForm = ({ onGoBack, onSubmit }: VerifyMfaFormProps) => (
  <div className="flex-col">
    {onGoBack && (
      <ClickableIcon
        name="chevron"
        rotate={180}
        className="mb-24 border rounded-full h-44 w-44"
        onClick={onGoBack}
      />
    )}

    <VerifyMfaByTotpForm onSubmit={onSubmit} />
  </div>
);

const VerifyMfaByTotpForm = ({
  onSubmit,
}: {
  onSubmit: (code: string) => Promise<"SUCCESS" | "ERROR">;
}) => {
  const t = useTranslation();

  return (
    <MfaCodeForm
      subtitle={t("verify_mfa_form.totp_subtitle")}
      onSubmit={onSubmit}
    />
  );
};
